export const messages = {
  en: {
    printerRule: {
      title: 'Printer Rule Management',
      addTitle: 'Add Printer Rule',
      editTitle: 'Edit Printer Rule',
      deleteTitle: 'Delete Printer Rule',
      ruleName: 'Rule Name',
      ruleNamePlaceholder: 'Please enter rule name',
      ruleNameRequired: 'Rule name is required',
      ruleNameMaxLength: 'Rule name cannot exceed 64 characters',
      remark: 'Remark',
      remarkPlaceholder: 'Please enter remark',
      remarkMaxLength: 'Remark cannot exceed 512 characters',
      state: 'State',
      deleteConfirm: 'Are you sure to delete this printer rule?',
      tab: {
        machine: 'Cloud Printer',
        fees: 'Fee Auto Print',
        repair: 'Repair Auto Print'
      }
    },
    printerRuleMachine: {
      title: 'Printer Machine Management',
      addTitle: 'Add Printer Machine',
      editTitle: 'Edit Printer Machine',
      deleteTitle: 'Delete Printer Machine',
      id: 'ID',
      idPlaceholder: 'Please enter ID',
      machineName: 'Printer Name',
      machineNamePlaceholder: 'Please enter printer name',
      machine: 'Printer',
      machinePlaceholder: 'Please select printer',
      machineRequired: 'Printer is required',
      quantity: 'Quantity',
      quantityPlaceholder: 'Please enter quantity',
      quantityRequired: 'Quantity is required',
      deleteConfirm: 'Are you sure to delete this printer machine?',
      table: {
        id: 'ID',
        machineName: 'Printer Name',
        quantity: 'Quantity'
      }
    },
    printerRuleFees: {
      title: 'Fee Auto Print Management',
      addTitle: 'Add Fee Auto Print',
      deleteTitle: 'Delete Fee Auto Print',
      id: 'ID',
      idPlaceholder: 'Please enter ID',
      feeName: 'Fee Name',
      feeNamePlaceholder: 'Please enter fee name',
      fee: 'Fee',
      feePlaceholder: 'Please select fee',
      feeRequired: 'Fee is required',
      deleteConfirm: 'Are you sure to delete this fee auto print?',
      table: {
        id: 'ID',
        feeName: 'Fee Name'
      }
    },
    printerRuleRepair: {
      title: 'Repair Auto Print Management',
      addTitle: 'Add Repair Auto Print',
      deleteTitle: 'Delete Repair Auto Print',
      id: 'ID',
      idPlaceholder: 'Please enter ID',
      repairType: 'Repair Type',
      repairTypePlaceholder: 'Please enter repair type',
      repairTypeRequired: 'Repair type is required',
      deleteConfirm: 'Are you sure to delete this repair auto print?',
      table: {
        id: 'ID',
        repairType: 'Repair Type'
      }
    }
  },
  zh: {
    printerRule: {
      title: '打印机规则管理',
      addTitle: '添加打印机规则',
      editTitle: '修改打印机规则',
      deleteTitle: '删除打印机规则',
      ruleName: '规则名称',
      ruleNamePlaceholder: '请输入规则名称',
      ruleNameRequired: '规则名称不能为空',
      ruleNameMaxLength: '规则名称不能超过64个字符',
      remark: '备注',
      remarkPlaceholder: '请输入备注',
      remarkMaxLength: '备注不能超过512个字符',
      state: '状态',
      deleteConfirm: '确定删除此打印机规则吗？',
      tab: {
        machine: '云打印机',
        fees: '缴费自动打印',
        repair: '报修自动打印'
      }
    },
    printerRuleMachine: {
      title: '打印机机器管理',
      addTitle: '添加打印机机器',
      editTitle: '修改打印机机器',
      deleteTitle: '删除打印机机器',
      id: '编号',
      idPlaceholder: '请输入编号',
      machineName: '打印机名称',
      machineNamePlaceholder: '请输入打印机名称',
      machine: '打印机',
      machinePlaceholder: '请选择打印机',
      machineRequired: '打印机不能为空',
      quantity: '打印数量',
      quantityPlaceholder: '请输入打印数量',
      quantityRequired: '打印数量不能为空',
      deleteConfirm: '确定删除此打印机机器吗？',
      table: {
        id: '编号',
        machineName: '打印机名称',
        quantity: '打印数量'
      }
    },
    printerRuleFees: {
      title: '缴费自动打印管理',
      addTitle: '添加缴费自动打印',
      deleteTitle: '删除缴费自动打印',
      id: '编号',
      idPlaceholder: '请输入编号',
      feeName: '费用名称',
      feeNamePlaceholder: '请输入费用名称',
      fee: '费用',
      feePlaceholder: '请选择费用',
      feeRequired: '费用不能为空',
      deleteConfirm: '确定删除此缴费自动打印吗？',
      table: {
        id: '编号',
        feeName: '费用名称'
      }
    },
    printerRuleRepair: {
      title: '报修自动打印管理',
      addTitle: '添加报修自动打印',
      deleteTitle: '删除报修自动打印',
      id: '编号',
      idPlaceholder: '请输入编号',
      repairType: '报修类型',
      repairTypePlaceholder: '请输入报修类型',
      repairTypeRequired: '报修类型不能为空',
      deleteConfirm: '确定删除此报修自动打印吗？',
      table: {
        id: '编号',
repairType: '报修类型'
      }
    }
  },
  'zh-TW': {
    printerRule: {
      title: '列印機規則管理',
      addTitle: '添加列印機規則',
      editTitle: '修改列印機規則',
      deleteTitle: '刪除列印機規則',
      ruleName: '規則名稱',
      ruleNamePlaceholder: '請輸入規則名稱',
      ruleNameRequired: '規則名稱不能為空',
      ruleNameMaxLength: '規則名稱不能超過64個字符',
      remark: '備註',
      remarkPlaceholder: '請輸入備註',
      remarkMaxLength: '備註不能超過512個字符',
      state: '狀態',
      deleteConfirm: '確定刪除此列印機規則嗎？',
      tab: {
        machine: '雲列印機',
        fees: '繳費自動列印',
        repair: '報修自動列印'
      }
    },
    printerRuleMachine: {
      title: '列印機機器管理',
      addTitle: '添加列印機機器',
      editTitle: '修改列印機機器',
      deleteTitle: '刪除列印機機器',
      id: '編號',
      idPlaceholder: '請輸入編號',
      machineName: '列印機名稱',
      machineNamePlaceholder: '請輸入列印機名稱',
      machine: '列印機',
      machinePlaceholder: '請選擇列印機',
      machineRequired: '列印機不能為空',
      quantity: '列印數量',
      quantityPlaceholder: '請輸入列印數量',
      quantityRequired: '列印數量不能為空',
      deleteConfirm: '確定刪除此列印機機器嗎？',
      table: {
        id: '編號',
        machineName: '列印機名稱',
        quantity: '列印數量'
      }
    },
    printerRuleFees: {
      title: '繳費自動列印管理',
      addTitle: '添加繳費自動列印',
      deleteTitle: '刪除繳費自動列印',
      id: '編號',
      idPlaceholder: '請輸入編號',
      feeName: '費用名稱',
      feeNamePlaceholder: '請輸入費用名稱',
      fee: '費用',
      feePlaceholder: '請選擇費用',
      feeRequired: '費用不能為空',
      deleteConfirm: '確定刪除此繳費自動列印嗎？',
      table: {
        id: '編號',
        feeName: '費用名稱'
      }
    },
    printerRuleRepair: {
      title: '報修自動列印管理',
      addTitle: '添加報修自動列印',
      deleteTitle: '刪除報修自動列印',
      id: '編號',
      idPlaceholder: '請輸入編號',
      repairType: '報修類型',
      repairTypePlaceholder: '請輸入報修類型',
      repairTypeRequired: '報修類型不能為空',
      deleteConfirm: '確定刪除此報修自動列印嗎？',
      table: {
        id: '編號',
        repairType: '報修類型'
      }
    }
  }
}